import { useState } from "react";
import { questionData } from "./HardCode.js";
import { useSelector } from "react-redux";
import { selectedLanguage } from "../../store/slices/selectedLanguageSlice.js";

const Question = () => {
  const [visibleIndex, setVisibleIndex] = useState(null);
  const selectedLanguages = useSelector(selectedLanguage);


  const toggleVisibility = (index) => {
    setVisibleIndex(visibleIndex === index ? null : index);
  };

  return (
    <section className="question">
      <div className="question__container container">
        <h2>{questionData[`${selectedLanguages}`][0]}</h2>
        <div className="question__context">
          {questionData[`${selectedLanguages}`][1].map((item, index) => (
            <div className="question__context-item" key={index}>
              <h3 onClick={() => toggleVisibility(index)} style={{ cursor: "pointer" }}>
                {item.title}
                <span
                  style={{
                    display: "inline-block",
                    transform: `rotate(${visibleIndex === index ? "180deg" : "0deg"})`,
                    transition: "transform 0.5s ease",
                  }}
                >
                  &#9013;
                </span>
              </h3>
              <p
                style={{
                  maxHeight: visibleIndex === index ? "200px" : "0px",
                  opacity: visibleIndex === index ? 1 : 0,
                  overflow: "hidden",
                  transition: "max-height 0.5s ease, opacity 0.5s ease",
                }}
              >
                {item.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Question;
